/**
 * Pure, feature-local derivations for the §8.1 card grid
 * (`TemplatesScreen.tsx`, REDISENO-PANEL.md §8.1). No React/I/O — same
 * "Extract-Before-Mock" convention every other v3 screen's own `derived.ts`
 * already established.
 */

/** §8.1's own 5-color band palette, gray reserved for an inactive template (never part of the hash rotation). */
const BAND_COLORS = ["#dbeafe", "#dcfce7", "#fef3c7", "#e0e7ff", "#fce7f3"] as const;
const INACTIVE_BAND_COLOR = "#f1f5f9";

/** A small, stable string hash (sum of char codes) — deterministic across renders/sessions for the same `templateId`, never random. */
function stableHash(value: string): number {
  let hash = 0;
  for (let i = 0; i < value.length; i++) {
    hash += value.charCodeAt(i);
  }
  return hash;
}

/** §8.1: "franja superior... con un color de fondo asignado por hash del templateId... gris si está inactiva." */
export function templateCardBandColor(templateId: string, activo: boolean): string {
  if (!activo) return INACTIVE_BAND_COLOR;
  return BAND_COLORS[stableHash(templateId) % BAND_COLORS.length]!;
}

/** §8.1: "las 2 primeras letras de producto en grande" — uppercased, never crashing on an empty/short product name. */
export function templateCardInitials(producto: string): string {
  return producto.trim().slice(0, 2).toUpperCase();
}
